export default {
  number: (num: number) => {
    if (num && !isNaN(num)) {
      return num.toLocaleString()
      // return new Intl.NumberFormat('en-US').format(parseInt(num))
    }
    return '0'
  },
}
